module.exports = __webpack_public_path__ + "img/icon-bell.ebafeacd.svg";